import React, { useEffect, useRef, useState } from 'react';
import './about.css';
import anonymous1 from '../../assets/anonymous2.png';

const skills = [
  { name: 'Development', percentage: 90, color: '#6366f1' },
  { name: 'Cyber Security', percentage: 80, color: '#8b5cf6' },
  { name: 'Content Creation', percentage: 95, color: '#a855f7' },
];

const stats = [
  { number: '7+', label: 'Years Experience', icon: '⚡' },
  { number: '50+', label: 'Projects Completed', icon: '🚀' },
  { number: '100K+', label: 'Community Reach', icon: '🌍' },
  { number: '24/7', label: 'Support Available', icon: '💡' },
];

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about" id="about" ref={sectionRef}>
      <div className="about__container">
        {/* Header */}
        <div className="about__header">
          <span className="about__badge">About Me</span>
          <h2 className="about__title">
            Know Me <span className="gradient-text">Better</span>
          </h2>
          <div className="about__underline"></div>
        </div>

        {/* Main Content */}
        <div className="about__grid">
          {/* Image Section */}
          <div className="about__image-wrapper">
            <div className="about__image-container">
              <div className="about__ring"></div>
              <img 
                src={anonymous1} 
                alt="Professor01" 
                className="about__image"
              />
              <div className="about__image-badge">
                <span className="badge-icon">👨‍💻</span>
                <span>CEO & Founder</span>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="about__content">
            <div className="about__greeting">
              <span className="greeting-emoji">👋</span>
              <span>Hello, I'm Professor01</span>
            </div>

            <p className="about__description">
              As the <span className="highlight">CEO of IT Pro Mastery (IPM)</span>, 
              I'm passionate about building exceptional digital experiences. 
              With expertise in <span className="highlight">full-stack development</span> 
              and <span className="highlight">cybersecurity</span>, I help businesses 
              create secure, scalable, and beautiful web solutions.
            </p>

            <p className="about__description">
              Through my content creation on YouTube and other platforms, 
              I share valuable insights about coding, security, and digital 
              innovation, empowering developers worldwide.
            </p>

            {/* Action Buttons */}
            <div className="about__actions">
              <a href="#contact" className="btn btn-primary">
                Let's Talk
              </a>
            </div>

            {/* Skills */}
            <div className="about__skills">
              {skills.map((skill, index) => (
                <div 
                  key={skill.name} 
                  className="skill-item"
                  style={{ transitionDelay: `${index * 0.1}s` }}
                >
                  <div className="skill-header">
                    <span className="skill-name">{skill.name}</span>
                    <span className="skill-percentage">{skill.percentage}%</span>
                  </div>
                  <div className="skill-bar">
                    <div 
                      className="skill-progress"
                      style={{ 
                        width: isVisible ? `${skill.percentage}%` : '0%',
                        background: `linear-gradient(90deg, ${skill.color}, ${skill.color}dd)`
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="about__stats">
          {stats.map((stat, index) => (
            <div key={stat.label} className="stat-card">
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;